export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: '1',
    name: '进口黄油推荐',
    slug: 'imported-butter',
    description: '精选法国、新西兰、日本等优质产地的进口黄油品牌评测与推荐',
    icon: 'ri-global-line',
    articleCount: 4,
  },
  {
    id: '2',
    name: '发酵黄油推荐',
    slug: 'fermented-butter',
    description: '发酵黄油品牌横向对比，深度解析发酵工艺带来的风味差异',
    icon: 'ri-test-tube-line',
    articleCount: 2,
  },
  {
    id: '3',
    name: '烘焙黄油推荐',
    slug: 'baking-butter',
    description: '针对不同烘焙场景的黄油选购建议，从饼干到可颂一网打尽',
    icon: 'ri-cake-3-line',
    articleCount: 3,
  },
  {
    id: '4',
    name: '家用黄油',
    slug: 'home-butter',
    description: '家庭日常使用的黄油选购指南，兼顾品质与性价比',
    icon: 'ri-home-4-line',
    articleCount: 2,
  },
  {
    id: '5',
    name: '黄油品牌对比',
    slug: 'brand-comparison',
    description: '多品牌黄油横向对比评测，用数据帮你做出明智选择',
    icon: 'ri-bar-chart-2-line',
    articleCount: 2,
  },
  {
    id: '6',
    name: '黄油选购指南',
    slug: 'buying-guide',
    description: '从入门到进阶的黄油选购知识，全面解答选购困惑',
    icon: 'ri-book-open-line',
    articleCount: 3,
  },
];